import { useEffect, useState } from "react";
import { getPaymentStats, filterPayments } from "../../services/paymentApi";

const PaymentDashboard = () => {
  const [stats, setStats] = useState(null);
  const [payments, setPayments] = useState([]);

  const [filters, setFilters] = useState({
    from: "",
    to: "",
  });

  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  // ===============================
  // LOAD STATS ONCE
  // ===============================
  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const data = await getPaymentStats(token);
      setStats(data);
    } catch (err) {
      console.error(err);
    }
  };

  // ===============================
  // SEARCH PAYMENTS (DATE RANGE ONLY)
  // ===============================
  const handleSearch = async () => {
    if (!filters.from || !filters.to) {
      alert("Please select date range");
      return;
    }

    try {
      setLoading(true);

      const data = await filterPayments(
        {
          from: filters.from + " 00:00:00",
          to: filters.to + " 23:59:59",
        },
        token
      );

      setPayments(data || []);
      setSearched(true);
    } catch (err) {
      console.error(err);
      setPayments([]);
      setSearched(true);
    } finally {
      setLoading(false);
    }
  };

  if (!stats) return <p>Loading...</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h2>💳 Payment Dashboard</h2>

      {/* ================= STATS ================= */}
      <div
        style={{
          display: "flex",
          gap: "15px",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        {[
          { label: "Orders", value: stats.orders.total_orders },
          { label: "Payments", value: stats.payments.total_payments },
          {
            label: "Success",
            value: stats.payments.success_payments,
            color: "green",
          },
          {
            label: "Failed",
            value: stats.payments.failed_payments,
            color: "red",
          },
          {
            label: "Pending",
            value: stats.payments.pending_payments,
            color: "orange",
          },
          {
            label: "Revenue",
            value: `₹${stats.payments.total_revenue || 0}`,
          },
        ].map((item, i) => (
          <div
            key={i}
            style={{
              padding: "15px",
              background: "#f1f5f9",
              borderRadius: "8px",
              minWidth: "120px",
              textAlign: "center",
              color: item.color || "#000",
            }}
          >
            <div style={{ fontSize: "14px" }}>{item.label}</div>
            <div style={{ fontSize: "18px", fontWeight: "bold" }}>
              {item.value}
            </div>
          </div>
        ))}
      </div>

      {/* ================= DATE FILTER ================= */}
      <div style={{ marginBottom: "20px" }}>
        <input
          type="date"
          value={filters.from}
          onChange={(e) =>
            setFilters({ ...filters, from: e.target.value })
          }
        />

        <input
          type="date"
          value={filters.to}
          onChange={(e) =>
            setFilters({ ...filters, to: e.target.value })
          }
          style={{ marginLeft: "10px" }}
        />

        <button
          onClick={handleSearch}
          style={{
            marginLeft: "10px",
            padding: "6px 12px",
            cursor: "pointer",
            background: "#1e293b",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
          }}
        >
          🔍 Search
        </button>
      </div>

      {/* ================= LOADING ================= */}
      {loading && <p>Loading...</p>}

      {/* ================= TABLE ================= */}
      {!searched ? (
        <p style={{ color: "#64748b" }}>
          Select date range and click search
        </p>
      ) : payments.length === 0 ? (
        <p style={{ color: "red" }}>No records found</p>
      ) : (
        <table border="1" cellPadding="10" width="100%">
          <thead style={{ background: "#e2e8f0" }}>
            <tr>
              <th>Order ID</th>
              <th>User</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Method</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {payments.map((p) => (
              <tr key={p.id}>
                <td>{p.order_id}</td>
                <td>{p.user_name}</td>
                <td>₹{p.amount}</td>

                <td>
                  <span
                    style={{
                      color:
                        p.status === "success"
                          ? "green"
                          : p.status === "failed"
                          ? "red"
                          : "orange",
                      fontWeight: "bold",
                    }}
                  >
                    {p.status}
                  </span>
                </td>

                <td>{p.payment_method}</td>

                <td>
                  {new Date(p.created_at).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PaymentDashboard;